<template>

        <!-- ============================================================== -->
        <!-- footer -->
        <!-- ============================================================== -->
        <footer class="footer" style="bottom:100%">
            © 2020 RTPMedicalSolution.com
        </footer>
        <!-- ============================================================== -->
        <!-- End footer -->
        <!-- ============================================================== -->
    
</template>

<script>
export default {
    
}
</script>

<style scoped>

</style>